import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawPinterestIcon from "./RawPinterestIcon.svg.jsx";

const PinterestIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawPinterestIcon} {...props} />;
});

export default PinterestIcon;
